import { AI_PLATFORM_URL } from './ai-platform.js';
import { referenceCaseDetails, referenceMaterialDetails } from './reference-data.js';
const seo = (title, description) => ({ title, description });
const qrConfig = () => ({
    image: '',
    title: '微信扫码，添加规划老师',
    description: '课程咨询 · 内测名额 · 测评入口，一对一回复',
});
const qrOverride = () => ({ enabled: false, config: qrConfig() });
const emptyLeadProfile = () => ({
    headline: '',
    teachingTag: '',
    serviceValue: '',
    serviceLabel: '',
    credentials: [],
    experience: [],
});
const courses = [
    {
        id: 'course-qihang',
        code: 'qihang',
        name: '雅思启航班',
        badge: '零基础入门',
        positioning: '70 节导学课打底 + 真人口语磨练，零基础也能稳步上岸',
        tags: ['直播 + 录播', '25–35 人管家式带班', '70 节导学 + 8 次口语对练', '含 AI 平台年卡'],
        audience: '零基础或 5.0 起步，目标 6.0 稳过，需要有人带着推进',
        highlights: ['25–35 人管家式带班', '70 节导学 + 70 节词汇', '直播 + 录播', '含 AI 平台年卡'],
        price: 499900,
        originalPrice: 599900,
        cover: '',
        sort: 1,
        sidebarNote: '零基础入门 · 管家式带学',
        qrOverride: qrOverride(),
        blocks: [
            {
                type: 'list',
                title: '适合人群',
                anchor: 'audience',
                sort: 1,
                data: {
                    items: [
                        '开始接触雅思的小白，对考试缺乏了解',
                        '想要走完备考流程但不清楚如何下手',
                        '自制力差，希望老师督学、营造学习氛围',
                        '系统学习雅思提升成绩，不知如何提升',
                        '全面提升听说读写综合能力，稳步跟班学',
                    ],
                    emphasisCards: [
                        { title: '考前 1v1 专属冲刺', text: '临考前针对薄弱项单独加练' },
                        { title: '针对性查漏补缺', text: '按阶段测评结果补短板' },
                        { title: '赠送 2 节 1v1 课程', text: '开课前预约，有效期内使用' },
                    ],
                },
            },
            {
                type: 'grid',
                title: '课程内容',
                anchor: 'content',
                sort: 2,
                data: {
                    columns: 3,
                    dashedLast: false,
                    cards: [
                        { title: '01', text: '70 节导学课 + 70 节基础词汇课 + 4 节一对一' },
                        { title: '02', text: '8 次口语强化模考对练 + 8 次写作精批' },
                        { title: '03', text: '不限次口语点评 + 写作范文 + 真人语伴口语练习' },
                        { title: '04', text: '基础语言能力巩固，词汇快速扫盲、强化认知' },
                        { title: '05', text: '从词到句逐项分析语法点' },
                        { title: '06', text: '结合当季考题侧重分配重难点' },
                        { title: '07', text: '讲解听说读写各项必考知识点，夯实基础能力' },
                        { title: '08', text: '教授提分解题思路、答题方法、核心技巧' },
                        { title: '09', text: '对问题针对性地强化训练，针对性地解决问题' },
                    ],
                },
            },
            {
                type: 'steps',
                title: '入学流程',
                anchor: 'enrolment',
                sort: 3,
                data: {
                    steps: [
                        { title: '入班水平测试', text: '可先免费完成 AI 入门测' },
                        { title: '制定专属学习计划', text: '根据目标分和备考周期安排任务' },
                        { title: '进入专属学习督学群', text: '老师与班主任同步跟进' },
                        { title: '开班导学 · 课程跟进', text: '明确学习方法和课程节奏' },
                        { title: '作业精讲辅批', text: '逐项反馈问题并安排巩固' },
                        { title: '真人口语磨练', text: '按考试流程完成口语对练' },
                        { title: '每日学习打卡监督', text: '持续跟进任务完成情况' },
                        { title: '查漏补缺', text: '根据阶段结果补足薄弱项' },
                        { title: '考前模拟', text: '熟悉考试流程与时间安排' },
                        { title: '课后答疑释疑 · 上岸', text: '持续答疑并完成考前收尾' },
                    ],
                },
            },
            {
                type: 'list',
                title: '管家式服务',
                anchor: 'service',
                sort: 4,
                data: {
                    items: [
                        '精选教师一对一个性化指导答疑，全套系统讲解',
                        '教辅多元化：4 科老师 + 1 位辅导老师 + 1 位班主任 + 1 位规划师',
                        '多方位督学：每日上课通知、催学、学习任务下发、监督及反馈',
                        '学习氛围极好：同学之间比学赶帮超',
                        '智慧教学 + ClassIn 课堂：监控学习进度，学习氛围浓厚',
                        '直播 + 录播相结合：上课时间灵活，随时巩固，专业老师不断线',
                        '三大阶段：全真模考、线上模拟测试、考前心理辅导',
                        '25–35 人管家式服务：全程贴身陪伴，拒绝散养',
                        '成交只是开始，及时响应是第一步——之后是持续在线服务',
                    ],
                    emphasisCards: [],
                },
            },
            {
                type: 'table',
                title: '同类课程对比',
                anchor: 'comparison',
                sort: 5,
                data: {
                    columns: ['对比项目', '萝卜雅思', '其他机构（常见）'],
                    rows: [
                        ['课程体量', '70 节导学 + 70 节词汇 + 4 节一对一', '录播打包，缺配套带练'],
                        ['口语写作', '8 次口语对练 + 8 次写作精批，不限次点评', '批改按次收费'],
                        ['督学', '1v1 计划 + 每日打卡监督 + 学习闭环回访', '下课即散，靠自觉'],
                    ],
                    fixedLeft: true,
                    highlightColumn: 1,
                },
            },
        ],
        seo: seo('雅思启航班｜萝卜雅思', '适合零基础或 5.0 起步学员的雅思 6.0 管家式带学课程。'),
    },
    {
        id: 'course-peiyou',
        code: 'peiyou',
        name: '雅思培优班',
        badge: '6.5 冲 7+',
        positioning: '48 小时直播精讲，冲刺班带你系统学习、科学备考',
        tags: ['直播授课', '8–12 人小班', '48h 直播 + 70 节录播导学', '含 AI 平台年卡'],
        audience: '有一定基础，6.0 左右冲 6.5–7.0，希望方法和练习同步推进',
        highlights: ['8–12 人小班', '48h 直播 + 70 节录播', '线上 + 线下', '含 AI 平台年卡'],
        price: 899900,
        originalPrice: 999900,
        cover: '',
        sort: 2,
        sidebarNote: '48h 直播精讲 · 8–12 人小班',
        qrOverride: qrOverride(),
        blocks: [
            {
                type: 'list',
                title: '适合人群',
                anchor: 'audience',
                sort: 1,
                data: {
                    items: [
                        '开始接触雅思的小白，对考试缺乏了解',
                        '想要快速夯实雅思基础',
                        '自制力差，希望老师督学、营造学习氛围',
                        '系统学习后提分犹豫，不知如何提升',
                        '希望全面提升听说读写综合能力',
                    ],
                    emphasisCards: [],
                },
            },
            {
                type: 'grid',
                title: '课程内容',
                anchor: 'content',
                sort: 2,
                data: {
                    columns: 4,
                    dashedLast: false,
                    cards: [
                        { title: '48h', text: '直播精讲课' },
                        { title: '41+29', text: '节录播导学课' },
                        { title: '真人语伴', text: '口语练习' },
                        { title: '10 次', text: '口语助教模考对练' },
                        { title: '10 次', text: '写作精批' },
                        { title: '2 次', text: '在线模考' },
                        { title: '2 节', text: '旗舰 1v1' },
                        { title: '含 AI 平台年卡', text: '作文批改 · 口语陪练 · 四科题库' },
                    ],
                },
            },
            {
                type: 'list',
                title: '课程能力训练',
                anchor: 'training',
                sort: 3,
                data: {
                    items: [
                        '基础语法巩固，帮助快速扫盲',
                        '从词到句，逐项分析语法运用',
                        '细致梳理历年考题重难点',
                        '讲解听说读写各项必考知识点',
                        '教授提分解题思路与核心技巧',
                        '对问题针对性地强化训练',
                    ],
                    emphasisCards: [],
                },
            },
            {
                type: 'table',
                title: '每周课表',
                anchor: 'schedule',
                sort: 4,
                data: {
                    columns: ['星期', '19:00–21:00 · 直播', '补充说明'],
                    rows: [
                        ['周一', '听力精讲', '第 1–2 节'],
                        ['周二', '口语精讲', '第 3–4 节'],
                        ['周三', '阅读精讲', '第 5–6 节'],
                        ['周四', '写作精讲', '第 7–8 节'],
                        ['周五', '口语助教对练', '每人 1v1 轮流约'],
                        ['周六', '阶段模考 / 精讲复盘', '按阶段结果查漏补缺'],
                        ['周日', '录播导学 + 自习答疑', '示例课表，以实际开班排期为准'],
                    ],
                    fixedLeft: true,
                    highlightColumn: 1,
                },
            },
            {
                type: 'grid',
                title: '机构地址与学习环境',
                anchor: 'location',
                sort: 5,
                data: {
                    columns: 2,
                    dashedLast: false,
                    cards: [
                        { title: '机构地址', text: '北京市海淀区长远天地大厦 A1 座 3A06' },
                        { title: '线下面授与自习区', text: '提供线下上课、自习和答疑空间' },
                    ],
                },
            },
            {
                type: 'steps',
                title: '学习流程',
                anchor: 'process',
                sort: 6,
                data: {
                    steps: [
                        { title: '入班水平测试', text: '可先免费完成 AI 入门测' },
                        { title: '制定专属学习计划', text: '按目标分和时间安排学习节奏' },
                        { title: '开班导学 + 督学群', text: '老师、助教与班主任同步跟进' },
                        { title: '上课 + 作业跟批 + 真人口语陪练', text: '讲练结合并持续反馈' },
                        { title: '阶段模考查漏补缺', text: '根据模考结果调整训练重点' },
                        { title: '考前冲刺与答疑', text: '完成考前复盘和状态调整' },
                    ],
                },
            },
            {
                type: 'grid',
                title: '管家式服务',
                anchor: 'service',
                sort: 7,
                data: {
                    columns: 3,
                    dashedLast: false,
                    cards: [
                        { title: '教师答疑', text: '教师一对一个性化答疑' },
                        { title: '多元教辅', text: '四科老师 + 辅导老师 + 班主任 + 规划老师' },
                        { title: '每日督学', text: '每日课程督促与任务下发' },
                        { title: '智慧课堂', text: 'ClassIn 课堂监控学习进度' },
                        { title: '直播 + 录播', text: '时间灵活，支持反复巩固' },
                        { title: '阶段模考', text: '全真模考与考前心理辅导' },
                    ],
                },
            },
            {
                type: 'table',
                title: '同类课程对比',
                anchor: 'comparison',
                sort: 8,
                data: {
                    columns: ['对比项目', '萝卜雅思', '其他机构（常见）'],
                    rows: [
                        ['直播课时', '100% 直播精讲 48h + 70 节录播导学', '录播为主，直播占比低'],
                        ['班型', '8–12 人小班 · 管家式带班', '大班课为主'],
                        ['口语练习', '10 次口语助教 1v1 模考对练', '无固定对练安排'],
                        ['写作批改', '10 次写作精批 + AI 批改随时练', '批改次数少或另收费'],
                        ['课后服务', '持续在线响应 · 督学到考前', '下课即散，答疑排队'],
                    ],
                    fixedLeft: true,
                    highlightColumn: 1,
                },
            },
            {
                type: 'ref',
                title: '相关出分案例',
                anchor: 'cases',
                sort: 9,
                data: { className: '基础强化班', limit: 3 },
            },
        ],
        seo: seo('雅思培优班｜萝卜雅思', '8–12 人小班，面向 6.0 左右基础、目标 6.5–7.0 的雅思课程。'),
    },
    {
        id: 'course-kaoguan',
        code: 'kaoguan',
        name: '考官全科班',
        badge: '前雅思考官亲授',
        positioning: '中外王牌师资联合授课，听说读写系统提升',
        tags: [
            '60H 四科精讲',
            '纯英文授课',
            '西式小组讨论课堂',
            '含 AI 平台年卡',
            '以考官标准为核心',
            '以提分效率为目标',
            '打造真正高效、可复制的雅思学习体系',
        ],
        audience: '目标 7.0+，需要考官视角的精修与纯英文环境',
        highlights: ['60H 四科精讲', '赠 70H 基础课', '纯英文授课', '含 AI 平台年卡'],
        price: 1099900,
        originalPrice: 1299900,
        cover: '',
        sort: 3,
        sidebarNote: '中外王牌师资联合授课 · 听说读写系统提升',
        qrOverride: qrOverride(),
        blocks: [
            {
                type: 'steps',
                title: '课程整体规划',
                anchor: 'plan',
                sort: 1,
                data: {
                    steps: [
                        { title: '系统基础提升 + 四科专项精讲', text: '从基础能力到专项方法完整推进' },
                        { title: '覆盖雅思听、说、读、写全模块', text: '四科统一规划，避免单项短板' },
                        { title: '直播精讲 + 讲练结合 + 课后巩固', text: '课堂输入、练习输出和课后复盘形成闭环' },
                        { title: '方法论 × 真题实战 × 能力提升并行', text: '以考官标准提升稳定得分能力' },
                    ],
                },
            },
            {
                type: 'grid',
                title: '口语 & 写作 ｜ 前雅思考官亲授',
                anchor: 'examiner',
                sort: 2,
                data: {
                    columns: 2,
                    dashedLast: false,
                    cards: [
                        { title: '前考官 LESP 四维教学法', text: '从语言、结构、思维、策略四个维度系统提升' },
                        { title: '纯英文授课', text: '与前考官直接互动，强化真实语言输出' },
                        { title: '西式小组讨论课堂', text: '模拟真实海外课堂与学术交流环境' },
                        { title: '高密度方法输入 + 练习输出', text: '确保随学随练，将方法转化为分数' },
                        {
                            title: '口语 15H',
                            text: 'Part 1 / Part 2 / Part 3 全覆盖；高频话题思路拆解、表达训练、失分点解析与考场应对',
                        },
                        {
                            title: '写作 15H',
                            text: 'Task 1 与 Task 2 主流题型全覆盖，训练段落结构、逻辑衔接和高频话题写作方法',
                        },
                    ],
                },
            },
            {
                type: 'grid',
                title: '听力 & 阅读 ｜ 萝卜雅思明星师资授课',
                anchor: 'listening-reading',
                sort: 3,
                data: {
                    columns: 2,
                    dashedLast: false,
                    cards: [
                        {
                            title: '听力 15H',
                            text: '系统梳理填空、选择、地图、匹配题；训练审题、破题、同义替换与易错难题复盘',
                        },
                        {
                            title: '阅读 15H',
                            text: '覆盖填空、判断、选择、配对题；训练快速定位、长难句解析与套题考点梳理',
                        },
                    ],
                },
            },
            {
                type: 'grid',
                title: '赠送课程',
                anchor: 'bonus',
                sort: 4,
                data: {
                    columns: 2,
                    dashedLast: false,
                    cards: [
                        { title: '70H 系统性基础夯实课程', text: '帮助基础薄弱或长期未系统学习的学员补足语言基础' },
                        { title: '与正课形成完整学习闭环', text: '基础课程、四科精讲与课后训练相互衔接' },
                    ],
                },
            },
            {
                type: 'grid',
                title: '全程配套服务，学习更安心',
                anchor: 'service',
                sort: 5,
                data: {
                    columns: 3,
                    dashedLast: false,
                    cards: [
                        { title: '全程陪伴式服务', text: '助教跟进、进度跟踪、作业督促、备考提醒与学习闭环回访' },
                        { title: '学习答疑保障', text: '口语写作由考官课堂答疑，听力阅读在课程有效期内持续答疑' },
                        { title: '口语陪练与写作精批', text: '赠送 18 次口语陪练与 16 篇写作精批' },
                        { title: '前考官作文批改', text: '每位学员享有 2 次前考官作文批改与具体修改建议' },
                        { title: '全科配套课程讲义', text: '课程有效期内不限次回放，支持反复复习与巩固' },
                        { title: '全真模考平台', text: '1:1 还原官方机考系统，收录剑 4–20 真题与独家考点真题' },
                    ],
                },
            },
        ],
        seo: seo('考官全科班｜萝卜雅思', '前雅思考官与中外师资联合授课的 7.0+ 全科精修课程。'),
    },
];
const materialRows = [
    [
        'speaking-new-topics',
        '口语换题季：9 月 Part 2 新题清单',
        '换题季新增题目逐题整理，附答题思路与素材方向',
        '9 月换题季',
        'PDF',
        '更新 2026-08',
        '3.2 万人领取',
        '新题',
    ],
    [
        'speaking-question-bank',
        '当季口语题库完整版（P1 / P2 / P3）',
        '全部当季话题配示例答案，可在小程序内直接练',
        '每月更新',
        '在线题库',
        '每月更新',
        '5.6 万人领取',
        '题库',
    ],
    [
        'writing-task2-samples',
        '写作 Task 2 高分范文 30 篇（带批注）',
        '按题型分类，每篇标注得分点与可复用句式',
        'Task 2',
        'PDF',
        '更新 2026-07',
        '2.8 万人领取',
        '范文',
    ],
    [
        'writing-band-report',
        '写作 6 → 6.5：考官报告扣分点解读',
        '对照考官报告拆解三个最常见扣分原因与改法',
        '考官报告',
        'PDF',
        '更新 2026-06',
        '1.9 万人领取',
        '扣分',
    ],
    [
        'cambridge-guide',
        '剑桥雅思真题使用方法指南',
        '使用顺序、复盘方法与教研组自编笔记',
        '剑 4–19',
        'PDF',
        '更新 2026-05',
        '4.1 万人领取',
        '真题',
    ],
    [
        'listening-intensive',
        '听力精听训练包（音频 + 逐句文本）',
        '30 段真题音频配逐句文本，适合每日精听',
        '音频 + 文本',
        '压缩包',
        '更新 2026-07',
        '2.2 万人领取',
        '精听',
    ],
    [
        'reading-paraphrases',
        '阅读同义替换 500 组',
        '按场景归类的高频同义替换，定位答案更快',
        '高频考点',
        'PDF',
        '更新 2026-04',
        '3.5 万人领取',
        '替换',
    ],
    [
        'eight-week-plan',
        '8 周首考 6.5 备考计划表',
        '按周拆解四科任务量，可直接打印执行',
        '首考 6.5',
        '表格',
        '更新 2026-08',
        '1.6 万人领取',
        '计划',
    ],
];
const materials = materialRows.map((row, index) => {
    const detail = referenceMaterialDetails[row[0]];
    return {
        id: `material-${index + 1}`,
        slug: row[0],
        title: row[1],
        summary: row[2],
        updated: row[5],
        claimed: row[6],
        cover: `/material-covers/${row[0]}.webp`,
        body: detail.body,
        includedTitle: '包含内容',
        included: [...detail.included],
        suitableForTitle: '适合谁',
        suitableFor: [...detail.suitableFor],
        howToClaimTitle: '如何领取',
        howToClaim: [...detail.howToClaim],
        qrCopy: row[7],
        qrOverride: qrOverride(),
        sort: index + 1,
        seo: seo(`${row[1]}｜萝卜雅思`, row[2]),
    };
});
const caseRows = [
    [
        'ao',
        '敖同学',
        '机考 · 听力单科重考',
        '定制 写作10h+听力5次',
        '一对一定制',
        '6.5',
        '7.0',
        '听力',
        'Sherry',
        '听力 +1.5',
        ['7.0', '6.5', '6.5', '7.0', '7.0'],
        '2026 年 8 月 20 日',
        '「感谢之前老师们的大力帮助！」',
    ],
    [
        'li',
        '李同学',
        '大三 · 申香港硕士',
        '备考 8 周',
        '雅思培优班',
        '5.5',
        '7.0',
        '写作',
        'Chris',
        '写作单项 +1.0',
        ['7.5', '7.5', '6.0', '6.5', '7.0'],
        '2026 年 5 月 16 日',
        '「写作一直卡 5.5，每天在平台写一篇让 AI 批，两周就看出哪些毛病是反复犯的。」',
    ],
    [
        'wang',
        '王同学',
        '在职 · 申英国硕士',
        '备考 12 周',
        '考官全科班',
        '6.0',
        '7.5',
        '口语',
        '桐桐',
        '在职备考',
        ['8.5', '8.5', '6.5', '7.0', '7.5'],
        '2026 年 7 月 25 日',
        '「上班族没时间上大班课，口语都是午休跟 AI 对练的。」',
    ],
    [
        'chen',
        '陈同学',
        '高三 · 申澳洲本科',
        '备考 10 周',
        '雅思启航班',
        '5.0',
        '6.5',
        '听力',
        'Avy',
        '零基础起步',
        ['7.0', '6.5', '6.0', '6.0', '6.5'],
        '2026 年 6 月 20 日',
        '「老师上课讲的方法，回家平台上马上能练，不会学完就忘。」',
    ],
    [
        'zhang',
        '张同学',
        '大四 · 申新加坡硕士',
        '备考 6 周',
        '考官全科班',
        '6.5',
        '7.5',
        '阅读',
        'Natalie',
        '六周冲刺',
        ['8.0', '8.5', '6.5', '7.0', '7.5'],
        '2026 年 4 月 11 日',
        '「阅读原来靠语感，讲完题型逻辑之后，判断题不再纠结。」',
    ],
    [
        'liu',
        '刘同学',
        '研一 · 交换项目申请',
        '备考 9 周',
        '雅思培优班',
        '5.0',
        '6.5',
        '写作',
        'Carol',
        '首考达标',
        ['6.5', '7.0', '6.0', '6.0', '6.5'],
        '2026 年 3 月 28 日',
        '「以前写作只会背模板，后来学会先想清楚观点再写。」',
    ],
    [
        'zhao',
        '赵同学',
        '在职 · 移民材料',
        '备考 14 周',
        '雅思启航班',
        '4.5',
        '6.5',
        '听力',
        'Rowling',
        '跨度 +2.0',
        ['7.0', '6.5', '6.0', '6.0', '6.5'],
        '2026 年 8 月 8 日',
        '「四十岁重新学英语，最怕没人盯。每周的复盘表让我知道自己在哪。」',
    ],
    [
        'sun',
        '孙同学',
        '大二 · 申英国本科',
        '备考 8 周',
        '雅思培优班',
        '6.0',
        '7.0',
        '口语',
        '桐桐',
        '口语 +1.5',
        ['7.5', '7.5', '6.0', '7.0', '7.0'],
        '2026 年 5 月 30 日',
        '「以前一紧张就背句子，现在能顺着考官的问题聊下去。」',
    ],
    [
        'zhou',
        '周同学',
        '高二 · 申美高衔接',
        '备考 11 周',
        '雅思启航班',
        '5.5',
        '7.0',
        '阅读',
        'Joanna',
        '在校生',
        ['7.5', '8.0', '6.0', '6.5', '7.0'],
        '2026 年 7 月 4 日',
        '「学业和备考冲突时，老师帮我把每周计划重排了三次。」',
    ],
    [
        'wu',
        '吴同学',
        '在职 · 申港校 MBA',
        '备考 7 周',
        '考官全科班',
        '6.5',
        '8.0',
        '写作',
        'Paul',
        '总分 8.0',
        ['8.5', '9.0', '7.0', '7.5', '8.0'],
        '2026 年 8 月 15 日',
        '「考官视角的批改最直接，他会告诉我这句在评分标准里算哪一档。」',
    ],
];
const cases = caseRows.map((row, index) => ({
    id: row[0],
    name: row[1],
    meta: row[2],
    weeks: row[3],
    className: referenceCaseDetails[row[0]].className,
    from: row[5],
    to: row[6],
    focus: row[7],
    teacher: row[8],
    tag: row[9],
    after: { l: row[10][0], r: row[10][1], w: row[10][2], s: row[10][3], o: row[10][4] },
    before: referenceCaseDetails[row[0]].before,
    date: row[11],
    enroll: referenceCaseDetails[row[0]].enroll,
    quote: row[12],
    backgroundTitle: '学员情况介绍',
    background: referenceCaseDetails[row[0]].background,
    pathTitle: '学习过程',
    path: [...referenceCaseDetails[row[0]].path],
    reviewTitle: '老师点评',
    review: referenceCaseDetails[row[0]].review,
    galleryTitle: '学习群实录',
    galleryDescription: '学员基础、学习过程、老师指导、班主任督学到提分报喜，均来自学员学习群真实记录 · 已获学员授权',
    shots: [...referenceCaseDetails[row[0]].shots],
    reportTitle: '雅思成绩单',
    reportImage: referenceCaseDetails[row[0]].reportImage,
    qrOverride: qrOverride(),
    sort: index + 1,
    seo: seo(`${row[1]}雅思提分案例｜萝卜雅思`, `${row[3]}，总分 ${row[5]} 提升至 ${row[6]}。`),
}));
const teachers = [
    {
        id: 'paul',
        name: 'Paul',
        score: '前 BC 雅思考官',
        subject: '口语 · 写作',
        education: '毕业于英国牛津大学，持剑桥大学教学资格认证',
        role: '曾在英国及上海担任 BC 雅思口语 & 写作考官',
        painPoints: ['写作论证深度', '口语高分表达'],
        description: '毕业于英国牛津大学，持剑桥大学教学资格认证，曾任曼彻斯特大学语言课程讲师，30 年以上一线教学经验，现任萝卜雅思考官课程负责人。',
        image: '/reference/assets/opt/paul-2.png',
        lead: true,
        leadProfile: {
            headline: '前雅思考官 · 现任萝卜雅思课程负责人',
            teachingTag: '纯英文授课',
            serviceValue: '100 万+',
            serviceLabel: '累计服务学员',
            credentials: ['毕业于英国牛津大学', '剑桥大学教学资格认证', '30+ 年一线教学经验'],
            experience: [
                '毕业于英国牛津大学 · 剑桥大学教学资格认证',
                '曾在英国及上海担任 BC 雅思口语 & 写作考官',
                '曾任曼彻斯特大学语言课程讲师',
                '现任萝卜雅思考官课程负责人',
            ],
        },
        qrOverride: qrOverride(),
        sort: 1,
    },
    {
        id: 'avy',
        name: 'Avy',
        score: '听力 9 分',
        subject: '听力',
        education: '留学于美国 · 香港应用英语语言学硕士',
        role: '教学 9 年，累计授课超过 12500 小时',
        painPoints: ['填空拼写与数字', '语速跟不上'],
        description: '教学 9 年，累计授课超过 12500 小时，深谙听力出题规律与高分技巧。课堂幽默耐心，与同学亦师亦友。',
        image: '/reference/assets/opt/avy.jpg',
        lead: false,
        leadProfile: emptyLeadProfile(),
        qrOverride: qrOverride(),
        sort: 2,
    },
    {
        id: 'tongtong',
        name: '桐桐',
        score: '口语 8.5 分',
        subject: '口语',
        education: '悉尼大学 · 教育学（TESOL）硕士',
        role: '前大型语培机构雅思口语组教研负责人',
        painPoints: ['背诵稿依赖', 'Part 3 追问接不住'],
        description: '口语教学 8 年，主导当季题库更新。不发模板，用学员自己的经历改写成高分素材，课堂大量真人追问练习。',
        image: '/reference/assets/t-tongtong.jpg',
        lead: false,
        leadProfile: emptyLeadProfile(),
        qrOverride: qrOverride(),
        sort: 3,
    },
    {
        id: 'natalie',
        name: 'Natalie',
        score: '阅读与听力双 9 分',
        subject: '阅读 · 听力',
        education: '香港中文大学 · 语言学硕士',
        role: '负责阅读题型教研',
        painPoints: ['判断题纠结', '长难句读得慢'],
        description: '7 年以上国际考试教学经验，负责阅读题型教研。讲课化繁为简，重视限时训练与干扰项复盘。',
        image: '/reference/assets/t-natalie.jpg',
        lead: false,
        leadProfile: emptyLeadProfile(),
        qrOverride: qrOverride(),
        sort: 4,
    },
    {
        id: 'chris',
        name: 'Chris',
        score: '写作 8.5 分',
        subject: '写作',
        education: '英国利兹大学 · 英语教育硕士',
        role: '前知名机构金牌讲师',
        painPoints: ['段落结构混乱', '论证展不开'],
        description: '专注雅思写作教学 9 年，万小时一线授课经验。先诊断反复犯的错误点，再按论证结构逐周加压，不背模板。',
        image: '/reference/assets/t-chris.jpg',
        lead: false,
        leadProfile: emptyLeadProfile(),
        qrOverride: qrOverride(),
        sort: 5,
    },
    {
        id: 'joanna',
        name: 'Joanna',
        score: '阅读 9 分',
        subject: '阅读',
        education: '上海外国语大学 · 英语语言文学硕士',
        role: 'TESOL 认证高级教师 · 英语专业八级',
        painPoints: ['标题匹配', '定位速度慢'],
        description: '教学十余年，课程逻辑清晰、循循善诱。按题型给出固定的定位路径，限时训练配合错题干扰项复盘。',
        image: '/reference/assets/t-joanna.jpg',
        lead: false,
        leadProfile: emptyLeadProfile(),
        qrOverride: qrOverride(),
        sort: 6,
    },
    {
        id: 'carol',
        name: 'Carol',
        score: '写作 8.5 分',
        subject: '写作',
        education: '墨尔本大学 · 应用语言学硕士',
        role: '专注雅思写作教学',
        painPoints: ['大作文结构松散', '提分偏慢'],
        description: '课堂高效紧凑，擅长在有限时间内大幅提分。按评分标准逐项加压，重点打磨论证结构与例证质量。',
        image: '/reference/assets/t-carol.jpg',
        lead: false,
        leadProfile: emptyLeadProfile(),
        qrOverride: qrOverride(),
        sort: 7,
    },
];
export const initialSiteSnapshot = {
    releaseId: 'seed-v1',
    generatedAt: '2026-09-07T00:00:00.000Z',
    brand: {
        name: '萝卜雅思',
        logo: '/reference/assets/logo-mark.png',
        aiPlatformUrl: AI_PLATFORM_URL,
        contact: '',
        leadSuccessMessage: '已提交，测评入口将发送至 {contact}',
        footerDescription: '先测出你差在哪，再用 AI 每天练，最后让老师带你复盘调整。十年雅思教研 + AI 全科学习平台。',
        companyName: '北京考满分教育咨询有限公司',
        filingNumber: '京ICP备 XXXXXXXX 号',
        userAgreementUrl: '#',
        privacyPolicyUrl: '#',
        defaultQr: {
            slot: 'global-default',
            image: '',
            title: '微信扫码，添加规划老师',
            description: '课程咨询 · 内测名额 · 测评入口，一对一回复',
            type: 'wecom_live',
            leadFallback: true,
        },
    },
    home: {
        hero: {
            eyebrow: '雅思官方白金级合作伙伴 · 机构代码 TS000409',
            title: '用 AI 重构雅思学习\n让每一次努力都有价值',
            highlightText: 'AI',
            description: '十年雅思教研结合 AI 学习平台，从入学测评、课程学习到每日陪练和老师复盘，让每一次练习都有反馈。',
            primaryCta: '免费测出我的雅思起点 →',
            primaryTarget: { kind: 'qr', slot: 'home-consult' },
            secondaryCta: '查看适合我的课程',
            secondaryTarget: { kind: 'anchor', id: 'sec-course' },
            trust: '约 10 分钟完成 · 四科能力分析 · 免费体验',
        },
        stats: [
            {
                value: 25000,
                suffix: '+',
                title: '学员成功出分',
                description: '2016 年至今累计出分学员',
            },
            {
                value: 80,
                suffix: '%',
                title: '单项提 1 分+',
                description: '入学一个月内至少一科提升 1 分',
            },
            {
                value: 95,
                suffix: '%',
                title: '申请到理想学校',
                description: '达到目标院校语言要求的学员占比',
            },
            {
                value: 10,
                suffix: ' 年',
                title: '雅思教研沉淀',
                description: '教研团队持续更新题库、讲义与批改标准',
            },
        ],
        aiTitle: '先免费体验，再决定怎么学',
        aiDescription: '写作和口语各有一套专业 AI，听力阅读正在内测；拿不准从哪开始，先做一次 10 分钟四科测评，或预约 1v1 规划。',
        aiProducts: [
            {
                key: 'plan',
                badge: '免费预约',
                name: '1v1 备考规划',
                subtitle: '规划师 · 25 分钟',
                description: '25 分钟，规划师根据你的情况给出提分路线和班型建议。',
                tags: ['提分路线', '班型建议', '时间安排'],
                cta: '预约规划',
                target: { kind: 'qr', slot: 'home-teacher' },
            },
            {
                key: 'writing',
                badge: '已上线',
                name: 'AI 写作',
                subtitle: '逐句批改 · 带写作文',
                description: '按官方评分标准逐句批改，也能从审题到成文带着写完一篇。',
                tags: ['四维评分', '逐句提升', '逐段带写', '高分范文'],
                cta: '体验 AI 写作',
                target: { kind: 'external', url: AI_PLATFORM_URL },
            },
            {
                key: 'speaking',
                badge: '已上线',
                name: 'AI 口语',
                subtitle: '24 小时陪练 · 当季题库',
                description: 'AI 教练 24 小时陪练，逐句纠错润色，当季题库与预测题都在小程序内。',
                tags: ['当季题库', 'P1–3 纠错', '预测题', 'P2 串题'],
                cta: '领取口语体验',
                target: { kind: 'qr', slot: 'home-consult' },
            },
            {
                key: 'listening',
                badge: '内测中',
                name: '听力 · 阅读',
                subtitle: '逐篇精听精读',
                description: '逐篇精听精读，配真经派原创解析，AI 训练正在内测。',
                tags: ['逐篇精听精读', '真经派解析'],
                cta: '加入等候名单',
                target: { kind: 'qr', slot: 'home-consult' },
            },
        ],
        productDetail: {
            eyebrow: '产品详解',
            title: 'AI 是怎么改作文、陪练口语的',
            description: '两套已经上线的专业 AI，逐句看它们怎么工作。',
        },
        writingFeatures: [
            {
                title: '四项对照评分',
                description: '按任务回应、连贯衔接、词汇、语法四项分别打分，看清哪一项拖分',
            },
            {
                title: '定位到具体句子',
                description: '直接标出有问题的那一句，而不是只给一个总分和笼统评语',
            },
            {
                title: '说明为什么扣分',
                description: '指出是搭配错误还是论证不足，并解释按评分标准的判断依据',
            },
            {
                title: '给出可以直接用的改法',
                description: '附修改后的完整句子和推荐表达，接受后同步回正文',
            },
        ],
        speakingFeatures: [
            {
                title: '当季在考题库',
                description: '同步当季题库并标注新题与高频预测，按 Part 1–3、话题和练习进度自选',
            },
            {
                title: '逐句纠错与润色',
                description: '点开看是哪个词发错、哪句语法有问题，并给出可以直接替换的说法',
            },
            {
                title: '素材定制与 P2 串题',
                description: '用你自己的经历改写成更高分的表达，一套素材覆盖多道 Part 2 题目',
            },
            {
                title: '四项能力对照',
                description: '发音、流利、词汇、语法分别打分，看清哪一项在拖分',
            },
        ],
        chatWall: {
            title: '「真实群聊截图」',
            description: '每一条都来自真实学员群聊',
            rating: '95% 学员好评',
            images: Array.from({ length: 8 }, (_, index) => `/reference/assets/x/chat-shot-${index + 1}.jpg`),
        },
        brandTrust: {
            intro: '萝卜雅思成立于 2016 年，前身为考满分 GRE 公众号，现隶属北京考满分教育咨询有限公司。十年专注出国留学生的雅思语培，秉持「学以致用、因材施教」——课上讲透的方法马上能在平台练，每个人的计划从自己的测评结果出发。',
            milestones: [
                { year: '2016', text: '创立于北京海淀，前身为考满分 GRE 公众号' },
                { year: '2022', text: '机考模拟平台上线，还原真实考场界面' },
                { year: '2023', text: '成为雅思官方（BC）白金级合作伙伴' },
                { year: '2025', text: 'AI 学习平台上线，写作批改与口语陪练开放' },
                { year: '2026', text: 'AI 口语陪练小程序全量开放' },
            ],
            awards: [
                { organization: '腾讯回响中国', title: '年度影响力国际教育品牌', year: '2018 · 2019' },
                { organization: '央广网', title: '年度口碑影响力教育机构', year: '2019 · 2020' },
                { organization: '网易新闻', title: '年度品牌满意度留学机构', year: '2018' },
                { organization: '搜狐', title: '年度品牌影响力留学机构', year: '2019' },
            ],
            certificates: [
                ['中国 3.15 诚信企业', 'cert-315'],
                ['中国著名留学语培品牌', 'cert-liuxue'],
                ['全国消费者放心满意品牌', 'cert-fangxin'],
                ['中国驰名品牌', 'cert-chiming'],
                ['留学行业信用 AAA 级', 'cert-aaa'],
            ].map(([title, file]) => ({
                title,
                thumbnail: `/reference/assets/opt/${file}.jpg`,
                image: `/reference/assets/x/${file}-full.jpg`,
            })),
        },
        process: [
            {
                title: '测评定位',
                items: ['完成四科能力测评', '确定目标分与考试时间', '生成第一阶段学习计划'],
            },
            {
                title: '老师教方法',
                items: ['小班课讲透题型方法', '建立听说读写解题框架', '课后任务当天就能练'],
            },
            {
                title: '双 AI 专项练习',
                items: [
                    '萝卜 AI 写作：逐句批改与带写',
                    '萝卜口语小程序：真题开口练',
                    '两个产品分别完成专项训练',
                ],
            },
            {
                title: '老师复盘调整',
                items: ['老师查看练习数据与错因', '每周复盘调整训练重点', '同步下一阶段任务'],
            },
            { title: '阶段复测', items: ['阶段复测确认提分', '对比四科分数变化', '确定下一阶段目标'] },
        ],
        faqs: [
            [
                '零基础适合哪个课程？',
                '建议从雅思启航班开始：先用 70 节导学课把语法和词汇打底，再进入题型训练，班主任每日打卡督学。',
            ],
            [
                'AI 批改和老师批改有什么区别？',
                'AI 负责即时反馈：四项评分、逐句语法与搭配修改、错因自动归档。老师负责论证结构、素材取舍和阶段计划调整，每周看你的练习数据决定下周重点。',
            ],
            ['线上课程是否支持回放？', '直播课均提供回放，录播课在 AI 学习平台年卡有效期内不限次观看。'],
            [
                '每周大约需要投入多长时间？',
                '建议每周 6–8 小时：2 小时课程，加每天 30–40 分钟平台练习。在职学员可以把练习拆到通勤和午休。',
            ],
            [
                '可以先体验 AI 工具吗？',
                '可以。能力测评、作文批改体验和口语对练都能先免费体验一次，不需要付费或报名。',
            ],
            [
                '如何选择适合自己的班型？',
                '先做免费测评拿到四科起点，再到「全部课程」页按基础、目标分和考试时间对比三个班型，规划老师会给出建议。',
            ],
            [
                '课程是否包含 AI 学习平台？',
                '三个班型都含 AI 学习平台年卡，区别在于老师精批和真人口语对练的次数。',
            ],
            [
                '如何预约能力测评？',
                '在本页底部填写称呼与联系方式，或扫码添加规划老师，24 小时内会发送测评入口。',
            ],
        ],
        faqIntro: {
            description: '备考规划、班型选择和 AI 产品使用，都可以直接问课程顾问。',
            bullets: [
                '工作日 9:00–21:00 在线',
                '一对一回复，不群发销售消息',
                '也可直接预约 1v1 备考规划',
            ],
            primaryCta: '咨询课程顾问',
            primaryTarget: { kind: 'qr', slot: 'home-consult' },
            secondaryCta: '或先做一次免费测评 →',
            secondaryTarget: { kind: 'anchor', id: 'sec-lead' },
        },
        lead: {
            title: '还不知道从哪里开始？先测出你的四科起点',
            description: '约 10 分钟了解当前水平、目标差距和优先提升方向。',
            button: '获取免费测评',
            hint: '规划老师会在 24 小时内发送测评入口，不会电话推销。',
        },
        activity: {
            enabled: true,
            tag: '限时',
            text: '2026 秋季班早鸟报名进行中，含 AI 学习平台年卡',
            button: '免费能力测评',
            target: { kind: 'qr', slot: 'home-consult' },
        },
        qrCodes: {
            teacher: qrConfig(),
            consult: qrConfig(),
            bottom: qrConfig(),
        },
    },
    courses,
    materials,
    cases,
    teachers,
    qrSlots: [
        { ...qrConfig(), slot: 'global-default', type: 'wecom_live', leadFallback: false },
    ],
    courseSettings: { defaultQr: qrConfig() },
    materialSettings: { defaultQr: qrConfig() },
    caseSettings: { defaultQr: qrConfig() },
    teacherSettings: { defaultQr: qrConfig() },
    about: {
        eyebrow: '关于萝卜雅思',
        title: '出国留学的口碑之选',
        intro: '萝卜雅思成立于 2016 年，十年专注出国留学生的雅思语培，秉持「学以致用、因材施教」——课上讲透的方法马上能在平台练，每个人的计划从自己的测评结果出发。',
        stats: [
            { value: '25,000+', label: '学员累计成功出分' },
            { value: '3,000+', label: '每年通过指导拿到目标分' },
        ],
        identity: '萝卜雅思成立于 2016 年，前身为考满分 GRE 公众号，现隶属北京考满分教育咨询有限公司。团队从内容社区起步，逐步建立起小班教学、教研与自研学习平台三条线，服务对象始终是准备出国留学的学生。',
        milestones: [
            { year: '2016', text: '创立于北京海淀' },
            { year: '2018–2020', text: '连续获腾讯、网易、央广网等媒体奖项' },
            { year: '2022', text: '雅思机考模拟网站上线' },
            { year: '2023', text: '成为雅思官方（BC）合作伙伴' },
            { year: '2025', text: 'AI 学习平台上线' },
        ],
        partnership: {
            title: '雅思官方白金级合作伙伴',
            note: '合作机构编号 TS000409，可向雅思官方核验',
            items: [
                '白金级为雅思官方合作伙伴体系中的最高级别',
                '国内数万家雅思培训机构中，仅少数获得官方认可',
                '官方定期提供权威考试资料与教师系统培训',
                '合作机构编号 TS000409，可向官方核验',
            ],
            disclaimer: 'IELTS 与 British Council 标识由官方授权使用\n合作关系有效期以官方证书原件为准',
        },
        principles: [
            {
                title: '学以致用',
                text: '课上讲透的方法必须当天能用起来。每节课对应平台上的练习模块，方法讲完就去练，练完当天出报告，方法有没有听懂，数据上直接看得见。',
            },
            {
                title: '因材施教',
                text: '每个人的计划从自己的测评结果出发。入学全科测评给出四科预测分与薄弱点，课程配比、任务量、模考节奏都按这份结果排，而不是按统一的课表走。',
            },
        ],
        methods: [
            {
                title: '入学先测，不先排课',
                text: '每位学员入学前完成全科测评，四科预测分与薄弱点决定课程配比与任务量。测评结果同时是后续调整计划的基线。',
            },
            {
                title: '一人一个学习顾问',
                text: '全程跟踪学习进度，定期评估效果并调整计划，问题当天有人回。顾问与授课教师共享同一份学习数据。',
            },
            {
                title: '模块化教学',
                text: '按题型拆成独立模块，每个模块解决一类具体问题，不做大而全的通讲。薄弱题型可以单独补，不必重上整门课。',
            },
            {
                title: '作业必批，错误归档',
                text: '写作与口语作业逐次批改，反复出现的错误进入个人错因库，考前集中清。错因库跟着学员走，换老师也不断档。',
            },
        ],
        chat: {
            title: '学习群实录',
            description: '上面四条不是口径。以下截图来自学员学习群的真实记录，均已获学员授权，个人信息部分打码。',
            images: Array.from({ length: 5 }, (_, index) => `/reference/assets/x/chat-shot-${index + 1}.jpg`),
            footnote: '截图来自学员学习群 · 已获学员授权 · 个人信息已打码',
        },
        support: '支持范围不止于课上。从入学测评、日常督学、模考安排，到出分后的留学申请咨询，学员在同一个团队里完成整个备考周期。每年有 3,000+ 名学员通过指导拿到目标分。',
        certificates: [
            ['中国 3.15 诚信企业', 'cert-315'],
            ['中国著名留学语培品牌', 'cert-liuxue'],
            ['全国消费者放心满意品牌', 'cert-fangxin'],
            ['中国驰名品牌', 'cert-chiming'],
            ['中国留学行业信用 AAA 级单位', 'cert-aaa'],
        ].map(([title, file]) => ({
            title,
            thumbnail: `/reference/assets/opt/${file}.jpg`,
            image: `/reference/assets/x/${file}-full.jpg`,
        })),
        awards: [
            { organization: '腾讯回响中国', title: '年度影响力国际教育品牌', year: '2018 · 2019' },
            { organization: '央广网', title: '年度口碑影响力教育机构', year: '2019 · 2020' },
            { organization: '网易新闻', title: '年度品牌满意度留学机构', year: '2018' },
            { organization: '搜狐', title: '年度品牌影响力留学机构', year: '2019' },
        ],
        office: {
            address: '北京市海淀区中关村互联网金融中心 12 层',
            images: ['', '', ''],
        },
    },
    navigation: [
        { label: '雅思写作', href: '/#tool-writing' },
        { label: '雅思口语', href: '/#tool-speaking' },
        { label: '课程推荐', href: '/courses' },
        { label: '备考资料', href: '/materials' },
        { label: '关于萝卜', href: '/about' },
        { label: '阅读 · 听力', href: '#', disabled: true },
    ],
    footer: [
        {
            title: 'AI 工具',
            links: [
                { label: 'AI 写作批改', href: AI_PLATFORM_URL },
                { label: 'AI 带写作文', href: AI_PLATFORM_URL },
                { label: 'AI 口语陪练', href: '/#tool-speaking' },
            ],
        },
        {
            title: '课程',
            links: courses.map((course) => ({ label: course.name, href: `/courses/${course.code}` })),
        },
        {
            title: '备考资料',
            links: [
                { label: '全部资料', href: '/materials' },
                ...materials.slice(0, 3).map((material) => ({
                    label: material.title,
                    href: `/materials/${material.slug}`,
                })),
            ],
        },
    ],
};
//# sourceMappingURL=seed.js.map